var _g, _path, _g2, _path2, _g3, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNof({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2370_85360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4734 7.98876L10.7537 7.29539C10.5997 7.13912 10.4117 6.81581 10.3569 6.61159L10.0193 5.35141C9.70564 4.18089 8.74734 3.35393 7.62934 3.14634C7.24754 2.75749 6.69329 2.6017 6.14539 2.74851C5.60246 2.89399 5.19307 3.31866 5.05818 3.85129C4.21636 4.5947 3.81219 5.77605 4.12183 6.93163L4.45949 8.19181C4.51422 8.39603 4.513 8.77006 4.45645 8.9774L4.17626 9.94402C4.06644 10.3311 4.12038 10.7117 4.33566 11.0171C4.54462 11.3188 4.89794 11.5017 5.29989 11.5275C6.35428 11.5973 7.41311 11.4844 8.42922 11.2121C9.44534 10.9399 10.4187 10.5082 11.2983 9.92553C11.6163 9.71754 11.8145 9.38148 11.8519 9.00309C11.8893 8.62471 11.753 8.25549 11.4734 7.98876Z",
    fill: "url(#paint0_linear_2370_85360)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96352 11.3368C9.90914 11.9707 9.46703 12.5323 8.81951 12.7058C8.42601 12.8112 7.99479 12.7559 7.64476 12.5454C7.44533 12.4387 7.2724 12.2715 7.14795 12.0859C7.21537 12.0785 7.28146 12.0662 7.35386 12.0575C7.47243 12.0417 7.59597 12.0246 7.71819 12.0025C8.00877 11.9514 8.30167 11.8889 8.59057 11.8115C8.87448 11.7354 9.15439 11.6444 9.42665 11.5448C9.52858 11.5068 9.63185 11.4738 9.72747 11.4321C9.80449 11.4008 9.88152 11.3695 9.96352 11.3368Z",
    fill: "url(#paint1_linear_2370_85360)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 3.91989,
    y: 2.43747,
    width: 9.54058,
    height: 9.45318
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0.17px)",
      clipPath: "url(#bgblur_0_2370_85360_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2370_85360)",
    "data-figma-bg-blur-radius": 0.343778
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9225 8.98987L12.3384 8.01799C12.2091 7.80604 12.0954 7.39765 12.0954 7.14951V6.18281C12.0954 4.30626 10.5704 2.78125 8.69902 2.78125C6.82248 2.78642 5.29746 4.30626 5.29746 6.18281V7.14434C5.29746 7.39248 5.18373 7.80087 5.05966 8.01282L4.47551 8.9847C4.25322 9.36207 4.20152 9.79115 4.3411 10.1634C4.48068 10.5407 4.79602 10.8406 5.20958 10.975C5.76789 11.1611 6.33137 11.2955 6.90519 11.3937C6.96205 11.404 7.01892 11.4092 7.07578 11.4196C7.14816 11.4299 7.2257 11.4402 7.30324 11.4506C7.43765 11.4712 7.57206 11.4868 7.71164 11.4971C8.03732 11.5281 8.36817 11.5436 8.69902 11.5436C9.0247 11.5436 9.35038 11.5281 9.67089 11.4971C9.78979 11.4868 9.90869 11.4764 10.0224 11.4609C10.1155 11.4506 10.2085 11.4402 10.3016 11.4247C10.3584 11.4196 10.4153 11.4092 10.4722 11.3989C11.0512 11.3058 11.625 11.1611 12.1833 10.975C12.5813 10.8406 12.8863 10.5407 13.0311 10.1582C13.1758 9.77047 13.1345 9.34657 12.9225 8.98987ZM9.0764 6.89103C9.0764 7.10815 8.90063 7.28392 8.68351 7.28392C8.46639 7.28392 8.29063 7.10815 8.29063 6.89103V5.28848C8.29063 5.07136 8.46639 4.89559 8.68351 4.89559C8.90063 4.89559 9.0764 5.07136 9.0764 5.28848V6.89103Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69922 2.91016C10.4991 2.91026 11.9667 4.3773 11.9668 6.18262V7.14941C11.9668 7.28951 11.9977 7.46618 12.0439 7.63184C12.09 7.79666 12.1549 7.96322 12.2275 8.08301V8.08398L12.8115 9.05566C13.0038 9.37933 13.0407 9.76213 12.9102 10.1123C12.7789 10.4591 12.5027 10.7306 12.1416 10.8525C11.5897 11.0364 11.0233 11.1797 10.4521 11.2715L10.4492 11.2725C10.3914 11.283 10.3401 11.2913 10.29 11.2959L10.2803 11.2979C10.1913 11.3127 10.1014 11.3226 10.0078 11.333H10.0049C9.89497 11.348 9.7795 11.3588 9.66016 11.3691H9.6582C9.34206 11.3997 9.02066 11.415 8.69922 11.415C8.37237 11.415 8.04517 11.3998 7.72363 11.3691L7.7207 11.3682C7.5849 11.3581 7.4541 11.3434 7.32324 11.3232H7.32031C7.24264 11.3129 7.16542 11.3022 7.09375 11.292H7.09277C7.06314 11.2868 7.03402 11.2829 7.00781 11.2793C6.97909 11.2754 6.95373 11.2711 6.92871 11.2666H6.92676C6.35848 11.1693 5.80117 11.0363 5.25 10.8525H5.24902C4.87102 10.7296 4.58702 10.4564 4.46191 10.1182L4.42285 9.99121C4.351 9.69055 4.40729 9.35474 4.58691 9.0498L4.58594 9.04883L5.16992 8.0791L5.1709 8.07812C5.24071 7.95886 5.30404 7.79148 5.34961 7.62598C5.39506 7.46077 5.42673 7.28449 5.42676 7.14453V6.18262C5.42686 4.43404 6.80332 3.00699 8.53125 2.91504L8.69922 2.91016ZM8.68359 4.7666C8.3954 4.7666 8.16232 4.99995 8.16211 5.28809V6.89062C8.16211 7.17894 8.39527 7.41309 8.68359 7.41309C8.97188 7.41304 9.20508 7.17892 9.20508 6.89062V5.28809C9.20487 4.99997 8.97174 4.76665 8.68359 4.7666Z",
    stroke: "#F0F8FE",
    strokeWidth: 0.257833
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69922 2.82422C10.5467 2.82433 12.0526 4.32992 12.0527 6.18262V7.14941C12.0527 7.27872 12.0819 7.44689 12.127 7.6084C12.1721 7.76993 12.2344 7.92942 12.3018 8.04004L12.8857 9.01172C13.0911 9.35728 13.131 9.76749 12.9912 10.1426C12.851 10.5131 12.5555 10.8043 12.1699 10.9346C11.7527 11.0737 11.3266 11.189 10.8965 11.2773L10.4658 11.3564H10.4648L10.2979 11.3818L10.2949 11.3828C10.2032 11.3981 10.1108 11.4076 10.0176 11.418H10.0166L9.66699 11.4541C9.34795 11.485 9.02348 11.501 8.69922 11.501C8.36973 11.501 8.04009 11.485 7.71582 11.4541H7.71484C7.57642 11.4438 7.44289 11.4287 7.30957 11.4082H7.30859C7.23116 11.3979 7.15403 11.3872 7.08203 11.377H7.08301C7.05365 11.3716 7.02421 11.3681 6.99609 11.3643C6.96765 11.3604 6.9403 11.3565 6.91309 11.3516H6.91211C6.3404 11.2537 5.77932 11.1198 5.22363 10.9346H5.22266C4.82097 10.804 4.51662 10.5127 4.38184 10.1484H4.38086C4.24648 9.79008 4.29613 9.37459 4.5127 9.00684L5.09668 8.03516V8.03418C5.16126 7.92378 5.22215 7.76498 5.2666 7.60352C5.31104 7.44207 5.34079 7.27391 5.34082 7.14453V6.18262C5.34092 4.33 6.84627 2.82932 8.69922 2.82422ZM8.68359 4.85254C8.44287 4.85254 8.24826 5.04741 8.24805 5.28809V6.89062C8.24805 7.13148 8.44274 7.32715 8.68359 7.32715C8.92441 7.3271 9.11914 7.13145 9.11914 6.89062V5.28809C9.11893 5.04744 8.92428 4.85258 8.68359 4.85254Z",
    stroke: "#F0F8FE",
    strokeWidth: 0.0859444
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 6.88669,
    y: 11.7187,
    width: 3.60845,
    height: 1.71881
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0.17px)",
      clipPath: "url(#bgblur_1_2370_85360_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2370_85360)",
    "data-figma-bg-blur-radius": 0.343778
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1513 12.0677C9.93414 12.6673 9.36032 13.0964 8.68828 13.0964C8.27989 13.0964 7.87666 12.931 7.59234 12.6363C7.42691 12.4812 7.30284 12.2745 7.23047 12.0625C7.29767 12.0728 7.36488 12.078 7.43725 12.0883C7.55615 12.1039 7.68022 12.1194 7.80429 12.1297C8.09895 12.1556 8.39878 12.1711 8.69862 12.1711C8.99328 12.1711 9.28795 12.1556 9.57744 12.1297C9.686 12.1194 9.79456 12.1142 9.89795 12.0987C9.98066 12.0883 10.0634 12.078 10.1513 12.0677Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43945 12.2178C7.55283 12.2325 7.67256 12.2478 7.79297 12.2578C8.09057 12.2839 8.39414 12.2998 8.69824 12.2998C8.99737 12.2998 9.29626 12.2839 9.58887 12.2578H9.58984C9.68963 12.2483 9.80949 12.2427 9.91699 12.2266L9.91602 12.2256C9.92383 12.2246 9.93164 12.2236 9.93945 12.2227C9.69663 12.6663 9.22696 12.9677 8.68848 12.9678C8.314 12.9678 7.94475 12.8154 7.68555 12.5469L7.68066 12.542L7.57617 12.4297C7.52362 12.3647 7.47889 12.2926 7.43945 12.2178Z",
    stroke: "#F0F8FE",
    strokeWidth: 0.257833
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32715 12.1182L7.43164 12.1309C7.5506 12.1464 7.67564 12.1624 7.80078 12.1729C8.09625 12.1988 8.39716 12.2139 8.69824 12.2139C8.99432 12.2139 9.2906 12.1988 9.58105 12.1729C9.68669 12.1628 9.79953 12.1573 9.9043 12.1416L9.90332 12.1406C9.96293 12.1332 10.0226 12.1266 10.084 12.1191C9.85565 12.6673 9.31657 13.0536 8.68848 13.0537C8.34115 13.0537 7.99769 12.9302 7.73242 12.708L7.62305 12.6064L7.62207 12.6045L7.50977 12.4844C7.42012 12.3737 7.35 12.2457 7.29785 12.1143C7.30763 12.1154 7.3174 12.1171 7.32715 12.1182Z",
    stroke: "#F0F8FE",
    strokeWidth: 0.0859444
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2370_85360",
    x: 4.01807,
    y: 2.69531,
    width: 7.83984,
    height: 9.19534,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.343778
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.171889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.735577 0 0 0 0 0.882277 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2370_85360"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2370_85360",
    x: 3.91989,
    y: 2.43747,
    width: 9.54058,
    height: 9.45318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.171889,
    result: "effect1_foregroundBlur_2370_85360"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2370_85360_clip_path",
    transform: "translate(-3.91989 -2.43747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9225 8.98987L12.3384 8.01799C12.2091 7.80604 12.0954 7.39765 12.0954 7.14951V6.18281C12.0954 4.30626 10.5704 2.78125 8.69902 2.78125C6.82248 2.78642 5.29746 4.30626 5.29746 6.18281V7.14434C5.29746 7.39248 5.18373 7.80087 5.05966 8.01282L4.47551 8.9847C4.25322 9.36207 4.20152 9.79115 4.3411 10.1634C4.48068 10.5407 4.79602 10.8406 5.20958 10.975C5.76789 11.1611 6.33137 11.2955 6.90519 11.3937C6.96205 11.404 7.01892 11.4092 7.07578 11.4196C7.14816 11.4299 7.2257 11.4402 7.30324 11.4506C7.43765 11.4712 7.57206 11.4868 7.71164 11.4971C8.03732 11.5281 8.36817 11.5436 8.69902 11.5436C9.0247 11.5436 9.35038 11.5281 9.67089 11.4971C9.78979 11.4868 9.90869 11.4764 10.0224 11.4609C10.1155 11.4506 10.2085 11.4402 10.3016 11.4247C10.3584 11.4196 10.4153 11.4092 10.4722 11.3989C11.0512 11.3058 11.625 11.1611 12.1833 10.975C12.5813 10.8406 12.8863 10.5407 13.0311 10.1582C13.1758 9.77047 13.1345 9.34657 12.9225 8.98987ZM9.0764 6.89103C9.0764 7.10815 8.90063 7.28392 8.68351 7.28392C8.46639 7.28392 8.29063 7.10815 8.29063 6.89103V5.28848C8.29063 5.07136 8.46639 4.89559 8.68351 4.89559C8.90063 4.89559 9.0764 5.07136 9.0764 5.28848V6.89103Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2370_85360",
    x: 6.88669,
    y: 11.7187,
    width: 3.60845,
    height: 1.71881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.171889,
    result: "effect1_foregroundBlur_2370_85360"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_2370_85360_clip_path",
    transform: "translate(-6.88669 -11.7187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1513 12.0677C9.93414 12.6673 9.36032 13.0964 8.68828 13.0964C8.27989 13.0964 7.87666 12.931 7.59234 12.6363C7.42691 12.4812 7.30284 12.2745 7.23047 12.0625C7.29767 12.0728 7.36488 12.078 7.43725 12.0883C7.55615 12.1039 7.68022 12.1194 7.80429 12.1297C8.09895 12.1556 8.39878 12.1711 8.69862 12.1711C8.99328 12.1711 9.28795 12.1556 9.57744 12.1297C9.686 12.1194 9.79456 12.1142 9.89795 12.0987C9.98066 12.0883 10.0634 12.078 10.1513 12.0677Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2370_85360",
    x1: 6.15158,
    y1: 2.74685,
    x2: 8.42047,
    y2: 11.2145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2370_85360",
    x1: 8.55507,
    y1: 11.7089,
    x2: 8.822,
    y2: 12.7051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNof);
export default __webpack_public_path__ + "static/media/nof.e38392f5660c9520d203ed1babfd896f.svg";
export { ForwardRef as ReactComponent };